export default __webpack_public_path__ + "static/1251-c9b3b4c7e7e4c48ebb4034845675655b.gif";